import {useMutation} from "@apollo/client";

import {ActionDialog} from "@/components/overlay/ActionDialog.tsx";
import {GQL_ACCOUNTUSER_RESEND_INVITE, GQL_ACCOUNTUSERS_QUERY} from "@/lib/queries/accounts.ts";
import {AccountUser} from "@/lib/types/accounts.ts";
import {GraphQLResponse, ResponseStatus} from "@/lib/types/common.ts";

export interface UserActionResendUserInviteProps {
  user: AccountUser;
  show: boolean;
  setShow: (show: boolean) => void;
}

export const UserActionResendUserInvite = ({user, show, setShow}: UserActionResendUserInviteProps) => {
  const [resendUserInvite, {data, reset, loading}] = useMutation<GraphQLResponse<null>>(GQL_ACCOUNTUSER_RESEND_INVITE, {
    refetchQueries: [GQL_ACCOUNTUSERS_QUERY],
  });

  const handleSubmit = async () => {
    const response = await resendUserInvite({
      variables: {
        id: user.id,
      },
    });
    if (response.data?.response.status === ResponseStatus.SUCCESS) {
      setShow(false);
    }
  };

  const serverErrors = data?.response?.status === ResponseStatus.ERROR ? data?.response?.message.__all__ : [];

  return (
    <ActionDialog
      show={show}
      loading={loading}
      title={serverErrors?.length > 0 ? "Unable to resend User invitation email" : "Resend Invitation Email"}
      onConfirm={handleSubmit}
      disableConfirmButton={serverErrors?.length > 0}
      cancelBtnText={serverErrors?.length > 0 ? "Close" : "Cancel"}
      confirmBtnText="OK"
      onCancel={() => {
        setShow(false);
        reset();
      }}
    >
      {serverErrors?.length > 0
        ? serverErrors[0]
        : `Are you sure you want to resend the invitation email to User "${user.first_name} ${user.last_name}" via ${user.email}?`}
    </ActionDialog>
  );
};
